import { useGridLoggerFactory } from './useGridLoggerFactory';
import { useGridApiInitialization } from './useGridApiInitialization';
import { useGridErrorHandler } from './useGridErrorHandler';
import { useGridLocaleText } from './useGridLocaleText';
import { useGridPipeProcessing } from './pipeProcessing';
import { useGridStrategyProcessing } from './strategyProcessing';
import { useGridStateInitialization } from './useGridStateInitialization';
/**
 * Initialize the technical pieces of the DataGrid (logger, state, ...) that any DataGrid implementation needs
 */

export const useGridInitialization = (inputApiRef, props) => {
  const apiRef = useGridApiInitialization(inputApiRef, props);
  useGridLoggerFactory(apiRef, props);
  useGridErrorHandler(apiRef, props);
  useGridStateInitialization(apiRef, props);
  useGridPipeProcessing(apiRef);
  useGridStrategyProcessing(apiRef);
  useGridLocaleText(apiRef, props);
  return apiRef;
};


//////////////////
// WEBPACK FOOTER
// ../@mui/x-data-grid/hooks/core/useGridInitialization.js
// module id = 2349
// module chunks = 25